import { createContext, useContext, type ReactNode } from "react";

import {
  type FilterAction,
  type FilterGroupConfig,
  type SelectedFilters,
} from "src/components/filterConfig";

interface DataTableContextValue {
  search: string;
  searchPlaceholder?: string;
  isFetching: boolean;
  filterConfig: FilterGroupConfig[];
  selectedFilters: SelectedFilters;
  hasActiveFilters: boolean;
  hideClearFilters: boolean;
  toolbarTrailing?: ReactNode;
  toolbarSecondaryContent?: ReactNode;
  filterSaveAction?: {
    label: string;
    onSelect: () => void;
  };
  onSearchChange: (search: string) => void;
  onFilterAction: (action: FilterAction) => void;
  clearFilters: () => void;
}

export const DataTableContext = createContext<DataTableContextValue | null>(
  null,
);

export function useDataTableContext() {
  const context = useContext(DataTableContext);

  if (!context) {
    throw new Error("useDataTableContext must be used within DataTable");
  }

  return context;
}
